// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.bg[data-v-0e199f16] {\n    width: 100%;\n    background-color: rgba(0, 0, 0, 60%);\n    z-index: 1;\n}\n.marquee[data-v-0e199f16] {\n    white-space: nowrap;\n    overflow: hidden;\n    box-sizing: border-box;\n    width: 100%;\n}\n.marquee span[data-v-0e199f16] {\n    display: inline-block;\n    padding-left: 100%;\n    animation: marquee 50s linear infinite;\n    animation-delay: 0.5s;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
